import React, { useEffect } from 'react';
import { makeStyles, createStyles, Theme, Typography, Button } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Utils from '../../utils';
import { OnSubmitDuplicate } from './action';

const styles = makeStyles((theme: Theme) =>
    createStyles({
        mainContainer: {
            '& .MuiTextField-root': {
                marginBottom: '10px!important',
            },
        },
        textStyl: {
            fontSize: '20px',
            color: 'var(--bar-orange)',
            margin: '44px 0 0 0',
        },
        textStylSmall: {
            font: 'normal normal normal 14px/21px Roboto',
            letterSpacing: '0.08px',
            opacity: 1,
            marginTop: '10px',
        },
        paper: {
            position: 'absolute',
            width: '25%',
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },
        saveContainer: {
            backgroundColor: 'white',
            padding: '10px 0',
            display: 'flex',
            justifyContent: 'center',
            marginTop: '25px',
        },
        cancelButton: {
            margin: '0 15px',
            minWidth: '100px',
            textAlign: 'center',
            font: 'normal normal medium 16px/20px Roboto',
            letterSpacing: '0.06px',
            color: '#515151',
            opacity: 1,
            height: '36px',
        },
        saveButton: {
            margin: '0 15px',
            minWidth: '100px',
            textAlign: 'center',
            font: 'normal normal medium 16px/20px Roboto',
            letterSpacing: '0.06px',
            color: '#FFFFFF',
            opacity: 1,
            height: '36px',
        },
    }),
);

export default function NotFound({ history, data }: any) {
    const classes = styles();
    const { t } = useTranslation();
    const dispatch = useDispatch();
    useEffect(() => {}, [dispatch]);
    function getModalStyle() {
        const top = 50;
        const left = 50;

        return {
            top: `${top}%`,
            left: `${left}%`,
            transform: `translate(-${top}%, -${left}%)`,
        };
    }

    const [modalStyle] = React.useState(getModalStyle);

    return (
        <div style={modalStyle} className={classes.paper}>
            <div className={classes.mainContainer}>
                <Typography className={classes.textStyl}>Same linesetup found</Typography>
                <Typography className={classes.textStylSmall}>Setup found for {data.lineName}</Typography>
                <Typography className={classes.textStylSmall}>{t('DoYouWanttoSetupLineNow')}</Typography>

                <div className={classes.saveContainer}>
                    <Button
                        variant="outlined"
                        size="large"
                        className={classes.cancelButton}
                        onClick={() => {
                            dispatch({
                                type: Utils.ActionName.LINE_SETUP,
                                payload: {
                                    validationForn: false,
                                    duplicate: false,
                                    overlapping: false,
                                },
                            });
                        }}
                    >
                        {t('CANCEL')}
                    </Button>
                    <Button
                        onClick={() => {
                            dispatch(OnSubmitDuplicate(history));
                        }}
                        color="primary"
                        size="large"
                        type="submit"
                        variant="contained"
                        className={classes.saveButton}
                    >
                        {t('ok')}
                    </Button>
                </div>
            </div>
        </div>
    );
}
